// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.lmphMuI0PGuZdXgRxsdJ {
  background-color: rgba(126, 150, 191, 0.6);
  height: 100dvh;
  width: 100vw;
  left: 0;
  position: fixed;
  top: 0;
  z-index: 999;
  overscroll-behavior: none;
}

.LGV05Eg8ZGut4izkinhB {
  background-color: white;
  border-radius: 10px;
  height: 561px;
  left: 50%;
  padding: 20px;
  position: relative;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 501px;

  .dixbM2nKV3zYYLIbNwwr {
    font-size: 10px;
    color: var(--black);
    margin-bottom: 20px;
    text-align: center;
  }
}

.LGV05Eg8ZGut4izkinhB > h2 {
  margin-top: 16px;
  text-align: left;
  font-size: 18px;
  margin-bottom: 10px;
}

.LGV05Eg8ZGut4izkinhB button.n_3ryAyqXB7LmgBGj7DE {
  background-color: #fff;
  cursor: pointer;
  height: 20px;
  position: absolute;
  right: 17px;
  top: 17px;
  width: 20px;
}

.LGV05Eg8ZGut4izkinhB h1 {
  font-size: 20px;
  margin-top: 30px;
  margin-bottom: 6px;
  text-align: left;
  font-weight: 700;
}

.LGV05Eg8ZGut4izkinhB p {
  color: #8d9bb8;
  display: block;
  font-size: 16px;
  font-style: normal;
  /* font-family: "Mulish", sans-serif; */
  font-weight: 400;
  line-height: 19px;
  margin-bottom: 24px;
  margin-top: 5px;
  text-align: left;

  span {
    color: var(--black);
  }
}

.ALwOaiM6ZHDV8ssLEx6U {
  background-color: var(--black);
  position: absolute;
  display: block;
  height: 60px;
  width: 60px;
}

.rowVAS1FPSI263ZFzpgs {
  background-color: black;
  display: block;
  height: 60px;
  width: 60px;
}

.FuDzPdwTeCVLXHKAYbhv {
  color: var(--white);
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%) scale(1.2);
}

/* -------Credentials----------- */
.wmSV3xh_UscC9mMcNO1q {
  margin-top: 10px;
  text-align: center;
}

.wmSV3xh_UscC9mMcNO1q input {
  background-color: var(--white);
  /*height: 60px;*/
  width: 100%;
  font-size: 14px;
}

.wmSV3xh_UscC9mMcNO1q input::placeholder {
  color: var(--dark-gray);
  display: inline;
  font-size: 14px;
}

.xIFkSlrA_Y9jj8ixuFUi {
  border-radius: 5px;
  border: 1px dashed #000000;
  display: flex;
  position: relative;
  height: 60px;
  overflow: hidden;
  width: 100%;
  margin-bottom: 15px;
  align-items: center;
  justify-content: center;
}

.wmSV3xh_UscC9mMcNO1q label > img {
  display: block;
  padding: 10px;
  z-index: 2;
}

.bjQvbcfNgpPHhz6NVHMW {
  position: absolute;
  color: var(--disabled-c);
  right: 0;
  top: 50%;
  transform: translate(-50%, -50%);
  cursor: pointer;
}

.xIFkSlrA_Y9jj8ixuFUi input {
  border: none;
  padding-left: 70px;
  width: 100%;
}

.xIFkSlrA_Y9jj8ixuFUi input:focus {
  outline: none;
}

.kuIdNzukFo4beoFFTl77 {
  width: 100%;
  color: var(--red);
  height: 32px;
  display: inline-block;
  font-size: 12px;
  text-align: start;
  overflow: hidden;
  padding: 0 4px;
  text-align: center;
}

/* --------qr---------- */
.wrYEKHFNhD0qhcSJrWo0 {
  align-items: center;
  display: flex;
  flex-direction: column;
  height: calc(100% - 120px);
  justify-content: center;
}
.G6IUSJiZvPnnTs30UHEC {
  height: calc(100% - 190px);
}

.wrYEKHFNhD0qhcSJrWo0 h3 {
  margin-bottom: 3vh;
}

.rgEivRqHuFyrj1jJIpeL {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  background-color: var(--blue);
  position: relative;
  margin-bottom: 8px;

  svg {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
  }
}

@media screen and (max-width: 548px) {
  .LGV05Eg8ZGut4izkinhB {
    padding: 28px 16px 16px 16px;
    width: calc(100% - 40px);
    height: max-content;

    p {
      margin-top: 0;
    }

    .GavLP9qxyN5lB8QKlkoa {
      display: flex;
      flex-direction: row;
      align-items: flex-start;
      width: 100%;
    }

    .YLSlLYhWk7NYY_wDvHnF {
      margin-right: 16px;
      height: 32px;
      min-width: 32px;
      width: 32px;
      color: var(--white);
      background-color: var(--black);
      border-radius: 5px;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 14px;
    }

    p {
      font-size: 12px;
      line-height: 16px;
      margin-bottom: 16px;
    }

    h1 {
      font-weight: 500;
      font-size: 16px;
      line-height: 22px;
      margin: 3px auto;
    }

    h2 {
      color: var(--black);
      font-weight: 400;
      text-align: center;
    }

    .dixbM2nKV3zYYLIbNwwr {
      font-size: 9px;
    }

    h3 {
      color: var(--roman-silver);
      font-weight: 400;
      font-size: 12px;
      line-height: 18px;
      /*width: 100%;*/

      span {
        color: var(--black);
      }
    }

    .UBic6RvxDtMDdWPgjHEC {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      width: 100%;
      margin-top: 14px;
      height: 40px;
      color: var(--white);
      background-color: var(--cadetGrey);
      border-radius: 5px;
      font-family: "Mulish Regular", sans-serif;
    }

    .FpxKca2A7rjjvK7rUmBo {
      margin-top: 17px;
      margin-bottom: 17px;
      width: 100%;
      height: 1px;
      background-color: var(--icon-gray);
    }
  }

  .wrYEKHFNhD0qhcSJrWo0 {
    height: 171px;
    margin-top: 16px;
  }

  .wmSV3xh_UscC9mMcNO1q input:disabled {
    background-color: transparent;
  }
}

.GZL4TpVSDkB4zGfa0X77 {
  padding-right: 50px !important;
}

.pkFjymE4hW55WLQ0yxdO {
  margin-top: 10px;
  width: 60%;
  overflow-x: hidden;
  overflow-wrap: break-word;
  text-align: center;
  max-height: 50%;
}

.U_C14lwCRhTcJhXbeMDl {
  margin-bottom: 8px;
  font-size: 14px;
  color: var(--blue);
  text-decoration: underline dotted transparent;
  text-underline-offset: 3px;
  transition: text-decoration-color 0.2s ease;
}
.U_C14lwCRhTcJhXbeMDl:hover {
  text-decoration-color: rgba(0, 102, 255, 0.5);
}

.ISStsPV_4gHTAIbeiBiT {
  list-style: none;
  padding: 0;
  width: 100%;
}
.Q_TddUqBuWRblv2rZjlE {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 0;
  border-radius: 8px;
  cursor: default;
  min-width: 0;
}

.KQa_O_a5A9vIYegZvzoA {
  background: none;
  border: none;
  cursor: pointer;
  color: var(--red);
}
.O54eGoq9z83bauaGoIxN {
  width: 100%;
  padding: 8px;
  flex: 1 0 auto;
  max-height: 184px;
  overflow-x: auto;
}
.L7O0IXIdMqXXqLHbp2EG {
  display: flex;
  align-items: center;
  gap: 10px;
  height: 20px;
  min-width: 0;
  flex: 1;
}
.liBsfdCSqtj78BoGqcTQ {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 50px;
  gap: 20px;
  padding-top: 10px;
  margin-top: auto;
  border-top: 1px solid #eee;
}
.sFwrMGnMPrI4PES1pFtc {
  display: block;
  min-width: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  transition: text-decoration 0.2s ease;
  text-decoration: underline transparent;
}
.Q_TddUqBuWRblv2rZjlE:hover .sFwrMGnMPrI4PES1pFtc {
  text-decoration: underline;
  text-decoration-color: rgba(24, 96, 217, 0.4);
  text-underline-offset: 3px;
}

.f8V_ve6GGe5A5iFuVGXc {
  display: flex;
  align-items: center;
  gap: 8px;
  color: var(--red);
  font-size: 14px;

  opacity: 0;
  transform: translateY(5px);
  transition:
    opacity 0.3s ease,
    transform 0.3s ease;
}

.OrOnQuuXycnTRQ6VUuGg {
  opacity: 1;
  transform: translateY(0);
}

.T1bT75zpyYxSifRnxrWJ {
  opacity: 0;
  transform: translateY(-5px);
}

._AsEqWVr2RXUuja7bBl4 {
  font-weight: 500;
}
.SzN_D1X2VIocOA5MDHDT {
  margin-bottom: 14px;
}
`, "",{"version":3,"sources":["webpack://./src/styles/Popup/Popup.module.css"],"names":[],"mappings":"AAAA;EACE,0CAA0C;EAC1C,cAAc;EACd,YAAY;EACZ,OAAO;EACP,eAAe;EACf,MAAM;EACN,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,SAAS;EACT,aAAa;EACb,kBAAkB;EAClB,QAAQ;EACR,gCAAgC;EAChC,YAAY;;EAEZ;IACE,eAAe;IACf,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;EACpB;AACF;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,WAAW;AACb;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,uCAAuC;EACvC,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;;EAEhB;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE,8BAA8B;EAC9B,kBAAkB;EAClB,cAAc;EACd,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,uBAAuB;EACvB,cAAc;EACd,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,2CAA2C;AAC7C;;AAEA,kCAAkC;AAClC;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,8BAA8B;EAC9B,gBAAgB;EAChB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,uBAAuB;EACvB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,0BAA0B;EAC1B,aAAa;EACb,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;EAChB,WAAW;EACX,mBAAmB;EACnB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,QAAQ;EACR,QAAQ;EACR,gCAAgC;EAChC,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,YAAY;EACZ,qBAAqB;EACrB,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA,yBAAyB;AACzB;EACE,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,0BAA0B;EAC1B,uBAAuB;AACzB;AACA;EACE,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,6BAA6B;EAC7B,kBAAkB;EAClB,kBAAkB;;EAElB;IACE,kBAAkB;IAClB,SAAS;IACT,QAAQ;IACR,gCAAgC;EAClC;AACF;;AAEA;EACE;IACE,4BAA4B;IAC5B,wBAAwB;IACxB,mBAAmB;;IAEnB;MACE,aAAa;IACf;;IAEA;MACE,aAAa;MACb,mBAAmB;MACnB,uBAAuB;MACvB,WAAW;IACb;;IAEA;MACE,kBAAkB;MAClB,YAAY;MACZ,eAAe;MACf,WAAW;MACX,mBAAmB;MACnB,8BAA8B;MAC9B,kBAAkB;MAClB,aAAa;MACb,uBAAuB;MACvB,mBAAmB;MACnB,eAAe;IACjB;;IAEA;MACE,eAAe;MACf,iBAAiB;MACjB,mBAAmB;IACrB;;IAEA;MACE,gBAAgB;MAChB,eAAe;MACf,iBAAiB;MACjB,gBAAgB;IAClB;;IAEA;MACE,mBAAmB;MACnB,gBAAgB;MAChB,kBAAkB;IACpB;;IAEA;MACE,cAAc;IAChB;;IAEA;MACE,0BAA0B;MAC1B,gBAAgB;MAChB,eAAe;MACf,iBAAiB;MACjB,eAAe;;MAEf;QACE,mBAAmB;MACrB;IACF;;IAEA;MACE,oBAAoB;MACpB,mBAAmB;MACnB,uBAAuB;MACvB,WAAW;MACX,gBAAgB;MAChB,YAAY;MACZ,mBAAmB;MACnB,kCAAkC;MAClC,kBAAkB;MAClB,yCAAyC;IAC3C;;IAEA;MACE,gBAAgB;MAChB,mBAAmB;MACnB,WAAW;MACX,WAAW;MACX,kCAAkC;IACpC;EACF;;EAEA;IACE,aAAa;IACb,gBAAgB;EAClB;;EAEA;IACE,6BAA6B;EAC/B;AACF;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,6CAA6C;EAC7C,0BAA0B;EAC1B,2CAA2C;AAC7C;AACA;EACE,6CAA6C;AAC/C;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,WAAW;AACb;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,YAAY;EACZ,YAAY;EACZ,OAAO;AACT;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,SAAS;EACT,iBAAiB;EACjB,gBAAgB;EAChB,0BAA0B;AAC5B;AACA;EACE,cAAc;EACd,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,qCAAqC;EACrC,sCAAsC;AACxC;AACA;EACE,0BAA0B;EAC1B,6CAA6C;EAC7C,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,eAAe;;EAEf,UAAU;EACV,0BAA0B;EAC1B;;uBAEqB;AACvB;;AAEA;EACE,UAAU;EACV,wBAAwB;AAC1B;;AAEA;EACE,UAAU;EACV,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;AAClB;AACA;EACE,mBAAmB;AACrB","sourcesContent":[".bg {\n  background-color: rgba(126, 150, 191, 0.6);\n  height: 100dvh;\n  width: 100vw;\n  left: 0;\n  position: fixed;\n  top: 0;\n  z-index: 999;\n  overscroll-behavior: none;\n}\n\n.box {\n  background-color: white;\n  border-radius: 10px;\n  height: 561px;\n  left: 50%;\n  padding: 20px;\n  position: relative;\n  top: 50%;\n  transform: translate(-50%, -50%);\n  width: 501px;\n\n  .disclaimer {\n    font-size: 10px;\n    color: var(--black);\n    margin-bottom: 20px;\n    text-align: center;\n  }\n}\n\n.box > h2 {\n  margin-top: 16px;\n  text-align: left;\n  font-size: 18px;\n  margin-bottom: 10px;\n}\n\n.box button.cross {\n  background-color: #fff;\n  cursor: pointer;\n  height: 20px;\n  position: absolute;\n  right: 17px;\n  top: 17px;\n  width: 20px;\n}\n\n.box h1 {\n  font-size: 20px;\n  margin-top: 30px;\n  margin-bottom: 6px;\n  text-align: left;\n  font-weight: 700;\n}\n\n.box p {\n  color: #8d9bb8;\n  display: block;\n  font-size: 16px;\n  font-style: normal;\n  /* font-family: \"Mulish\", sans-serif; */\n  font-weight: 400;\n  line-height: 19px;\n  margin-bottom: 24px;\n  margin-top: 5px;\n  text-align: left;\n\n  span {\n    color: var(--black);\n  }\n}\n\n.labelLogo {\n  background-color: var(--black);\n  position: absolute;\n  display: block;\n  height: 60px;\n  width: 60px;\n}\n\n.keyformLabel {\n  background-color: black;\n  display: block;\n  height: 60px;\n  width: 60px;\n}\n\n.logo {\n  color: var(--white);\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%) scale(1.2);\n}\n\n/* -------Credentials----------- */\n.keyform {\n  margin-top: 10px;\n  text-align: center;\n}\n\n.keyform input {\n  background-color: var(--white);\n  /*height: 60px;*/\n  width: 100%;\n  font-size: 14px;\n}\n\n.keyform input::placeholder {\n  color: var(--dark-gray);\n  display: inline;\n  font-size: 14px;\n}\n\n.keybox {\n  border-radius: 5px;\n  border: 1px dashed #000000;\n  display: flex;\n  position: relative;\n  height: 60px;\n  overflow: hidden;\n  width: 100%;\n  margin-bottom: 15px;\n  align-items: center;\n  justify-content: center;\n}\n\n.keyform label > img {\n  display: block;\n  padding: 10px;\n  z-index: 2;\n}\n\n.eye {\n  position: absolute;\n  color: var(--disabled-c);\n  right: 0;\n  top: 50%;\n  transform: translate(-50%, -50%);\n  cursor: pointer;\n}\n\n.keybox input {\n  border: none;\n  padding-left: 70px;\n  width: 100%;\n}\n\n.keybox input:focus {\n  outline: none;\n}\n\n.error {\n  width: 100%;\n  color: var(--red);\n  height: 32px;\n  display: inline-block;\n  font-size: 12px;\n  text-align: start;\n  overflow: hidden;\n  padding: 0 4px;\n  text-align: center;\n}\n\n/* --------qr---------- */\n.qr {\n  align-items: center;\n  display: flex;\n  flex-direction: column;\n  height: calc(100% - 120px);\n  justify-content: center;\n}\n.qr_withBtn {\n  height: calc(100% - 190px);\n}\n\n.qr h3 {\n  margin-bottom: 3vh;\n}\n\n.plusIcon {\n  width: 30px;\n  height: 30px;\n  border-radius: 50%;\n  background-color: var(--blue);\n  position: relative;\n  margin-bottom: 8px;\n\n  svg {\n    position: absolute;\n    left: 50%;\n    top: 50%;\n    transform: translate(-50%, -50%);\n  }\n}\n\n@media screen and (max-width: 548px) {\n  .box {\n    padding: 28px 16px 16px 16px;\n    width: calc(100% - 40px);\n    height: max-content;\n\n    p {\n      margin-top: 0;\n    }\n\n    .variant {\n      display: flex;\n      flex-direction: row;\n      align-items: flex-start;\n      width: 100%;\n    }\n\n    .numbers {\n      margin-right: 16px;\n      height: 32px;\n      min-width: 32px;\n      width: 32px;\n      color: var(--white);\n      background-color: var(--black);\n      border-radius: 5px;\n      display: flex;\n      justify-content: center;\n      align-items: center;\n      font-size: 14px;\n    }\n\n    p {\n      font-size: 12px;\n      line-height: 16px;\n      margin-bottom: 16px;\n    }\n\n    h1 {\n      font-weight: 500;\n      font-size: 16px;\n      line-height: 22px;\n      margin: 3px auto;\n    }\n\n    h2 {\n      color: var(--black);\n      font-weight: 400;\n      text-align: center;\n    }\n\n    .disclaimer {\n      font-size: 9px;\n    }\n\n    h3 {\n      color: var(--roman-silver);\n      font-weight: 400;\n      font-size: 12px;\n      line-height: 18px;\n      /*width: 100%;*/\n\n      span {\n        color: var(--black);\n      }\n    }\n\n    .button {\n      display: inline-flex;\n      align-items: center;\n      justify-content: center;\n      width: 100%;\n      margin-top: 14px;\n      height: 40px;\n      color: var(--white);\n      background-color: var(--cadetGrey);\n      border-radius: 5px;\n      font-family: \"Mulish Regular\", sans-serif;\n    }\n\n    .divider {\n      margin-top: 17px;\n      margin-bottom: 17px;\n      width: 100%;\n      height: 1px;\n      background-color: var(--icon-gray);\n    }\n  }\n\n  .qr {\n    height: 171px;\n    margin-top: 16px;\n  }\n\n  .keyform input:disabled {\n    background-color: transparent;\n  }\n}\n\n.inputeye {\n  padding-right: 50px !important;\n}\n\n.uploadKeyName {\n  margin-top: 10px;\n  width: 60%;\n  overflow-x: hidden;\n  overflow-wrap: break-word;\n  text-align: center;\n  max-height: 50%;\n}\n\n.replaceLink {\n  margin-bottom: 8px;\n  font-size: 14px;\n  color: var(--blue);\n  text-decoration: underline dotted transparent;\n  text-underline-offset: 3px;\n  transition: text-decoration-color 0.2s ease;\n}\n.replaceLink:hover {\n  text-decoration-color: rgba(0, 102, 255, 0.5);\n}\n\n.fileList {\n  list-style: none;\n  padding: 0;\n  width: 100%;\n}\n.fileItem {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 8px 0;\n  border-radius: 8px;\n  cursor: default;\n  min-width: 0;\n}\n\n.removeBtn {\n  background: none;\n  border: none;\n  cursor: pointer;\n  color: var(--red);\n}\n.filesContainer {\n  width: 100%;\n  padding: 8px;\n  flex: 1 0 auto;\n  max-height: 184px;\n  overflow-x: auto;\n}\n.fileInfo {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  height: 20px;\n  min-width: 0;\n  flex: 1;\n}\n.statusFooter {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  height: 50px;\n  gap: 20px;\n  padding-top: 10px;\n  margin-top: auto;\n  border-top: 1px solid #eee;\n}\n.fileName {\n  display: block;\n  min-width: 0;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  transition: text-decoration 0.2s ease;\n  text-decoration: underline transparent;\n}\n.fileItem:hover .fileName {\n  text-decoration: underline;\n  text-decoration-color: rgba(24, 96, 217, 0.4);\n  text-underline-offset: 3px;\n}\n\n.errorWrapper {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  color: var(--red);\n  font-size: 14px;\n\n  opacity: 0;\n  transform: translateY(5px);\n  transition:\n    opacity 0.3s ease,\n    transform 0.3s ease;\n}\n\n.visible {\n  opacity: 1;\n  transform: translateY(0);\n}\n\n.hidden {\n  opacity: 0;\n  transform: translateY(-5px);\n}\n\n.errorText {\n  font-weight: 500;\n}\n.mb14 {\n  margin-bottom: 14px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"bg": `lmphMuI0PGuZdXgRxsdJ`,
	"box": `LGV05Eg8ZGut4izkinhB`,
	"disclaimer": `dixbM2nKV3zYYLIbNwwr`,
	"cross": `n_3ryAyqXB7LmgBGj7DE`,
	"labelLogo": `ALwOaiM6ZHDV8ssLEx6U`,
	"keyformLabel": `rowVAS1FPSI263ZFzpgs`,
	"logo": `FuDzPdwTeCVLXHKAYbhv`,
	"keyform": `wmSV3xh_UscC9mMcNO1q`,
	"keybox": `xIFkSlrA_Y9jj8ixuFUi`,
	"eye": `bjQvbcfNgpPHhz6NVHMW`,
	"error": `kuIdNzukFo4beoFFTl77`,
	"qr": `wrYEKHFNhD0qhcSJrWo0`,
	"qr_withBtn": `G6IUSJiZvPnnTs30UHEC`,
	"plusIcon": `rgEivRqHuFyrj1jJIpeL`,
	"variant": `GavLP9qxyN5lB8QKlkoa`,
	"numbers": `YLSlLYhWk7NYY_wDvHnF`,
	"button": `UBic6RvxDtMDdWPgjHEC`,
	"divider": `FpxKca2A7rjjvK7rUmBo`,
	"inputeye": `GZL4TpVSDkB4zGfa0X77`,
	"uploadKeyName": `pkFjymE4hW55WLQ0yxdO`,
	"replaceLink": `U_C14lwCRhTcJhXbeMDl`,
	"fileList": `ISStsPV_4gHTAIbeiBiT`,
	"fileItem": `Q_TddUqBuWRblv2rZjlE`,
	"removeBtn": `KQa_O_a5A9vIYegZvzoA`,
	"filesContainer": `O54eGoq9z83bauaGoIxN`,
	"fileInfo": `L7O0IXIdMqXXqLHbp2EG`,
	"statusFooter": `liBsfdCSqtj78BoGqcTQ`,
	"fileName": `sFwrMGnMPrI4PES1pFtc`,
	"errorWrapper": `f8V_ve6GGe5A5iFuVGXc`,
	"visible": `OrOnQuuXycnTRQ6VUuGg`,
	"hidden": `T1bT75zpyYxSifRnxrWJ`,
	"errorText": `_AsEqWVr2RXUuja7bBl4`,
	"mb14": `SzN_D1X2VIocOA5MDHDT`
};
export default ___CSS_LOADER_EXPORT___;
